import React from 'react';
import { connect } from 'react-redux';
import * as uiActions from '../../store/ui/actions';

import Button from 'Components/Button';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class InviteTeachersButton extends React.Component {
  render() {
    return (
      <Button
        label={
          <ConnectedFormattedMessage id="users_list.invite_teacher_button.label" />
        }
        buttonType="secondary-mono"
        ctaIcon="plus"
        ctaIconBefore={true}
        clickHandler={() => this.props.showModal('invite-teachers')}
      />
    );
  }
}

export default connect(false, uiActions)(InviteTeachersButton);
